/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/faq'>.
 * /r/-хвост не-exact легаси (§3.2)
 */
import { createFileRoute, notFound } from '@tanstack/react-router';
import CacheDataRoute from '../../../CacheDataRoute';
import AskChef from '@routes/AskChef';
import { getQueryClient } from '../../../providers/query';
import { faqsAllInfiniteQueryOptions } from '@queries/index';
import { getURLProps } from '@utils/setPagesUrl';
import { isContentNotFoundError } from '../../../api/contentNotFound';
import { assertValidListUrl } from '../../../ssrListParams';

export const Route = createFileRoute('/faq/r/$')({
  /**
   * ЭТАП 2 — честный 404 несуществующей страницы вопросов
   * (/faq/r/page/99999): бэк (getFaqsAll) кидает CONTENT_NOT_FOUND через
   * PaginationHelper.checkPageExists (и checkPageNumber для page < 1)
   * -> notFound() -> HTTP 404 + контент /404 без редиректа.
   * ensureInfiniteQueryData дедуплицируется с root-префетчем (тот же ключ:
   * поиск '' и mePeopleIdFilter false — состояние первого рендера), лишнего
   * запроса нет. page 1 не проверяем (пустой раздел — норма, как на бэке);
   * клиентскую навигацию не блокируем.
   */
  loader: async ({ location }) => {
    if (typeof window !== 'undefined') {
      return;
    }
    // Хвост /r/ обязан быть каноническим: чужие ключи, битые значения
    // и /r/page/1 — честный 404, см. src/ssrListParams.ts
    assertValidListUrl('faq', location.pathname);
    const page = parseInt(
      `${getURLProps({ pathname: location.pathname }).page}`,
      10
    );
    if (!Number.isFinite(page) || page === 1) {
      return;
    }
    const queryClient = getQueryClient();
    const options = faqsAllInfiniteQueryOptions({
      search: '',
      mePeopleIdFilter: false,
      initialPage: page
    });
    // Префетч успел упасть раньше — ошибка уже в кэше, без второго запроса
    const settled = queryClient.getQueryState(options.queryKey);
    if (settled?.error) {
      if (isContentNotFoundError(settled.error)) {
        throw notFound();
      }
      return;
    }
    try {
      await queryClient.ensureInfiniteQueryData(options);
    } catch (error) {
      if (isContentNotFoundError(error)) {
        throw notFound();
      }
    }
  },
  component: () => <CacheDataRoute component={AskChef} path='/faq' />
});
